import React from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@emotion/react';
import { theme } from '../configs/theme.es.js';

const ThemeProvider = ({
  theme: theme$1 = theme,
  children
}) => {
  return /* @__PURE__ */ React.createElement(ThemeProvider$1, {
    theme: theme$1
  }, children);
};
function useTheme() {
  const theme = useTheme$1();
  return theme;
}

export { ThemeProvider, useTheme };
